import axios from 'axios';
import { IGrundleistung } from '@/shared/model/grundleistung.model';
const baseApiUrl = 'api/grundleistung';

export default class GrundleistungService {
  public retrieve(): Promise<any> {
    return axios.get(`${baseApiUrl}`);
  }

  public delete(id: String, force: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}/${force}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<IGrundleistung> {
    return new Promise<IGrundleistung>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IGrundleistung): Promise<IGrundleistung> {
    return new Promise<IGrundleistung>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IGrundleistung): Promise<IGrundleistung> {
    return new Promise<IGrundleistung>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
